import * as React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import './table-head.scss';

import type { TableAlign, TableWidth } from 'types';

type Props = {
  width?: TableWidth,
  align?: TableAlign,
  fontSize?: 'small' | 'normal' | 'medium',
  fontWeight?: 'normal' | 'bold',
  children?: React.ReactNode,
  customModifier?: string,
  className?: string
};

const TableHead = ({
  width = 'auto',
  align = 'left',
  fontSize = 'normal',
  fontWeight = 'normal',
  children,
  customModifier,
  className
}: Props): JSX.Element => {
  const classes = classnames({
    'table-head': true,
    [`table-head--width-${width}`]: width,
    [`table-head--align-${align}`]: align,
    [`table-head--font-size-${fontSize}`]: fontSize,
    [`table-head--font-weight-${fontWeight}`]: fontWeight,
    [`table-head--${customModifier ?? ''}`]: !isNil(customModifier),
    [String(className)]: Boolean(className)
  });

  return (
    <section className={classes}>
      {children}
    </section>
  );
};

export default TableHead;
